import React from 'react';
import { Chip } from '@mui/material';

export type LicenseStatusType = 'active' | 'expiring_soon' | 'expired' | 'no_expiry';

interface LicenseStatusBadgeProps {
  status: LicenseStatusType;
  size?: 'small' | 'medium';
}

const STATUS_CONFIG: Record<LicenseStatusType, { label: string; color: 'success' | 'warning' | 'error' | 'default' }> = {
  active: { label: 'Active', color: 'success' },
  expiring_soon: { label: 'Expiring', color: 'warning' },
  expired: { label: 'Expired', color: 'error' },
  no_expiry: { label: 'No Expiry', color: 'default' },
};

const LicenseStatusBadge: React.FC<LicenseStatusBadgeProps> = ({ status, size = 'small' }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.no_expiry;

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      variant="outlined"
    />
  );
};

export default LicenseStatusBadge;
